export default {
  currentStat: 1,
}
